export default "__VITE_ASSET__BSD1FQ1B__"